import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import { XRayDealerApiResponse, DealerExportApiResponse } from '../interfaces/x-ray-dealer.interface';

@Injectable({
  providedIn: 'root',
})
export class XRayDealerReportsService extends BaseApiService {
  // Tornar anoExercicio opcional com valor padrão null
  getXRayData(
    dn: number,
    anoExercicio: number | null = null,
    tipoSegmento: string = 'VAREJO'
  ): Observable<XRayDealerApiResponse> {
    let endpoint = `/reports/dealer?dn=${dn}&tipoSegmento=${tipoSegmento}`;

    // Só adiciona anoExercicio se não for null/undefined
    if (anoExercicio !== null && anoExercicio !== undefined) {
      endpoint += `&anoExercicio=${anoExercicio}`;
    }

    return this.get<XRayDealerApiResponse>(endpoint);
  }

  // Método específico para pegar apenas os dados (data[0]) - AGORA COM anoExercicio OPCIONAL
  getXRayDataOnly(
    dn: number,
    anoExercicio: number | null = null,
    tipoSegmento: string = 'VAREJO'
  ): Observable<{ data: any; availableExercicios: string[] }> {
    return this.getXRayData(dn, anoExercicio, tipoSegmento).pipe(
      map((response) => ({
        data: response.data[0],
        availableExercicios: response.filters.availableExercicios || []
      }))
    );
  }

  /**
   * Dados para exportação Excel: período (start/end) e DN. Backend não usa tipoSegmento.
   */
  getDealerExportData(
    period: { start: { year: number; month: number }; end: { year: number; month: number } },
    dn: number
  ): Observable<DealerExportApiResponse> {
    const params = `dn=${dn}&startYear=${period.start.year}&startMonth=${period.start.month}&endYear=${period.end.year}&endMonth=${period.end.month}`;
    return this.get<DealerExportApiResponse>(`/reports/dealer/export?${params}`);
  }
}
